/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

import OfferDetailsHeader from './OfferDetailsHeader';
import OfferDetailsTexts from './OfferDetailsTexts';
import OfferDetailsIcons from './OfferDetailsIcons';
import OfferDetailsCta from './OfferDetailsCta';
import Footer from '../../common/Footer';
import { companyInfoPropsType } from '../../../helpers/fetchCmsContent';

const OfferDetails = ({
    t, openPage, language, item, claim, companyInfo
}) => (
    <div className="offer-details-content" key={ item.translations.slug }>
        <OfferDetailsHeader t={ t } openPage={ openPage } language={ language } item={ item }/>
        { item.translations.description && <OfferDetailsTexts item={ item }/> }
        { item.use_cases.length > 0 && <OfferDetailsIcons item={ item }/> }
        { item.ctas.length > 0 && <OfferDetailsCta openPage={ openPage } language={ language } item={ item }/> }
        <Footer t={ t } openPage={ openPage } language={ language } claim={ claim } companyInfo={ companyInfo }/>
    </div>
);

OfferDetails.defaultProps = {
    companyInfo: null
};

OfferDetails.propTypes = {
    t: PropTypes.func.isRequired,
    openPage: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    item: PropTypes.shape().isRequired,
    claim: PropTypes.string.isRequired,
    companyInfo: companyInfoPropsType
};

export default OfferDetails;



// WEBPACK FOOTER //
// ./src/components/content/offer/details/OfferDetails.jsx